module.exports = __webpack_public_path__ + "img/AD9E81_F1E5CE_6B5C3E_5A492A-256px.f4038382.png";